<!-- Pre Select the campaign, distributor and producer -->
<template>
  <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0" v-text="title"></h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <h5 class="text-center info-text" v-text="subtitle"></h5>

        <campaign-select v-model="campaign" />

        <distributor-select
          v-if="$can('index', 'distributors') && !preloadedProducer"
          v-model="distributor"
          :empty-cuit-filter="emptyDistributorCuitFilter"
        />

        <producer-select
          v-if="!preloadedProducer"
          ref="producerSelect"
          v-model="producer"
          :distributor="distributor"
          :empty-cuit-filter="emptyProducerCuitFilter"
        />

        <div class="text-right">
          <base-button :disabled="!isSelected" type="primary" @click="onSelect">Seleccionar</base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import DistributorSelect from '@/components/ModelSelects/DistributorSelect';
import ProducerSelect from '@/components/ModelSelects/ProducerSelect';

export default {
  components: {
    CampaignSelect,
    DistributorSelect,
    ProducerSelect,
  },

  props: {
    title: {
      type: String,
      default: 'Seleccione campaña y productor',
    },

    subtitle: {
      type: String,
      required: true,
    },

    preloadedProducer: {
      type: Boolean,
      default: false,
    },

    emptyDistributorCuitFilter: {
      type: Boolean,
      default: null,
    },

    emptyProducerCuitFilter: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      producer: null,
      distributor: null,
      campaign: null,
    };
  },

  computed: {
    isSelected() {
      return (this.producer || this.preloadedProducer) && this.campaign;
    },
  },

  watch: {
    distributor() {
      this.$refs.producerSelect.clearSelection();
      this.producer = null;
    },
  },

  methods: {
    onSelect() {
      this.$emit('selected', this.producer, this.campaign);
    },
  },
};
</script>
